import React, { useContext, useEffect, useState } from 'react';
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import { AddCircle, Delete } from '@material-ui/icons';
import FormContext from 'components/Form/FormContext';
import ImageWithDropzone from 'components/Image/ImageWithDropzone';
import { LabelImageThumbnail } from 'features/PpsiContainer/constants';

const useStyles = makeStyles(() => ({
  tableHeader: {
    background: '#a6c9ec',
    padding: '3px',
    fontWeight: 'bold',
    marginBottom: '5px'
  },
  addButton: {
    float: 'right',
    marginTop: '20px'
  }
}));

const LabelTabContent = () => {
  const classes = useStyles();
  const { data, setFieldValue } = useContext(FormContext);
  const [labelList, setLabelList] = useState(data.dishLabel || []);

  // Sync state with updated context value
  useEffect(() => {
    if (
      data.dishLabel &&
      JSON.stringify(data.dishLabel) !== JSON.stringify(labelList)
    ) {
      console.log('Syncing labelList with data.dishLabel:', data.dishLabel);
      setLabelList(data.dishLabel);
    }
  }, [data.dishLabel, labelList]);

  const addDishLabel = () => {
    const newLabel = { logoId: '', dishLogo: null };
    const updatedList = [...labelList, newLabel];
    setLabelList(updatedList);
    setFieldValue('dishLabel', updatedList);
  };

  const onDeleteDishLabel = deletedIndex => {
    const updatedList = labelList.filter((_, index) => index !== deletedIndex);
    setLabelList(updatedList);
    setFieldValue('dishLabel', updatedList);
  };

  const onChangeMainImage = (imgData, index) => {
    const updatedList = labelList.map((item, i) =>
      i === index ? { ...item, dishLogo: imgData } : item
    );
    setLabelList(updatedList);
    setFieldValue('dishLabel', updatedList);
  };

  return (
    <div>
      <Grid container spacing={2} rowSpacing={1}>
        <Grid item sm={3} className={classes.tableHeader}>
          Image
        </Grid>
        <Grid item sm={1} className={classes.tableHeader} />
      </Grid>
      {labelList.length === 0 ? (
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item sm={3} />
          <Grid item sm={1}>
            <IconButton
              onClick={addDishLabel}
              color="secondary"
              size="small"
              className={classes.addButton}
            >
              <AddCircle />
            </IconButton>
          </Grid>
        </Grid>
      ) : (
        labelList.map((item, index) => (
          <Grid container spacing={2} sx={{ mt: 1 }} key={index}>
            <Grid item sm={3}>
              <div style={{ width: '50px' }}>
                <ImageWithDropzone
                  image={item.dishLogo}
                  thumbnailWidth={LabelImageThumbnail.Width}
                  thumbnailHeight={LabelImageThumbnail.Height}
                  onUploadImage={imgData => onChangeMainImage(imgData, index)}
                  size="small"
                  action="label"
                  isUsed={item.used}
                  logoUseIn={item.logoUseIn}
                />
              </div>
            </Grid>
            <Grid item sm={1}>
              {item.logoId === '' && (
                <IconButton
                  onClick={() => onDeleteDishLabel(index)}
                  style={{ color: '#d11a2a', marginTop: '20px' }}
                  size="small"
                >
                  <Delete />
                </IconButton>
              )}
              {index === labelList.length - 1 && (
                <IconButton
                  onClick={addDishLabel}
                  color="secondary"
                  size="small"
                  className={classes.addButton}
                >
                  <AddCircle />
                </IconButton>
              )}
            </Grid>
          </Grid>
        ))
      )}
    </div>
  );
};

export default LabelTabContent;
